import { createApp } from 'vue'
import App from '@/vue/public/App.vue'
import { key, store } from '@/vue/store'
import { i18n, store as i18nStore, key as i18nKey } from '@/vue/i18n'
import '@/vue/axios'
import init from '@/vue/sentry'

const app = createApp(App)
init(app)
app.use(store, key)
app.use(i18n)
app.use(i18nStore, i18nKey)
app.mount('#app')
